import React from 'react'
import Navbar from '../components/Navbar';
import { useParams } from 'react-router-dom'
import projectImgTwo from '../assets/makoko/makoko2.jpeg';
import projectImgOne from '../assets/makoko/makoko1.jpeg';
import projectImgFour from '../assets/makoko/makoko4.jpeg';
import projectImgFive from '../assets/makoko/makoko5.jpeg';
import projectImgThree from '../assets/makoko/makoko3.jpeg';
import Footer from '../components/Footer';


interface IImageGalleryProps {
    images: Array<string>
}


const ImageGallery:React.FC<IImageGalleryProps> = ({ images }) => {
    return (
        <div className="grid md:grid-cols-2 gap-2">
            {images.map((image, index) => (
                <div key={index} className="relative w-full overflow-hidden">
                    <img src={image} alt={`Image ${index + 1}`} className="w-full h-full object-cover" />
                </div>
            ))}
        </div>
    );
};

const ProjectDetailView = () => {
    const { projectId } = useParams()

    const images = [projectImgTwo, projectImgOne, projectImgThree, projectImgFour, projectImgFive]

    return (
        <>
            <main className='bg-[#FFFAE5] pb-4'>
                <Navbar inverse={true} />

                <header>
                    <div className='min-h-[420px] bg-center bg-no-repeat bg-cover' style={{ backgroundImage: `url(${projectImgTwo})` }}></div>
                </header>

                <section className='lg:w-10/12 mx-auto'>
                    <div className='p-4 flex flex-col gap-6 lg:flex-row lg:place-items-center'>
                        <div className=''>
                            <h4 className='text-xl italic tf-bellafair font-light'>(2024)</h4>
                            <h1 className='text-5xl lg:text-8xl uppercase tf-rozha'>Makoko Outreach</h1>
                        </div>

                        <div className='lg:w-8/12'>
                            <h3 className='tf-rozha font-semibold text-2xl leading-relaxed hidden'>nothing here to show</h3>
                        </div>
                    </div>

                    <article className='p-4 space-y-6'>
                        <p className='tf-inter text-[#0E101199] leading-loose '>
                            In the bustling heart of Lagos, nestled amidst its waterways, lies the community of Makoko—a vibrant, resilient neighborhood often referred to as the “Venice of Africa.” Yet, for all its uniqueness, Makoko faces numerous socioeconomic challenges. This year, in 2024, we embarked on an impactful journey of hope and transformation, bringing essential support, education, and the message of love to this extraordinary community.
                        </p>
                        <p className='tf-inter text-[#0E101199] leading-loose'>
                            The Makoko Outreach aimed to uplift students and families by addressing immediate needs while sowing seeds for lasting impact. Our approach combined three key elements:
                            <ul className='mt-3'>
                                <li><b>Provision of Resources:</b> Distributing supplies to improve learning conditions and daily living.</li>
                                <li><b>Humanitarian Care:</b>Offering hands-on support and comfort to residents.</li>
                                <li><b>Gospel Outreach:</b>Sharing a message of faith, love, and hope to empower minds and uplift spirits.</li>
                            </ul>
                        </p>
                    </article>
                    
                    <article className='p-4 space-y-6'>
                        <p className='tf-inter text-[#0E101199] leading-loose'>The Makoko Outreach 2024 is only a stepping stone in a longer journey. While this visit made an immediate impact, the true measure of success lies in its ability to spark a ripple effect, enabling students to excel, families to hope again, and the community to find sustainable pathways to prosperity. As we reflect on this year's outreach, we are filled with gratitude for all the partners, supporters, and volunteers who made this initiative a reality. Makoko is not just a symbol of challenges but of potential, inspiration, and the human spirit's unyielding ability to thrive amidst adversity. Together, we have taken a step toward transforming that potential into reality.</p>
                    </article>
                </section>

                <ImageGallery images={images} />
            </main>

            <Footer />
        </>
    )
}

export default ProjectDetailView